import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Langs = _resolveComponent("Langs")!

  return (_ctx.showLangs)
    ? (_openBlock(), _createBlock(_component_Langs, {
        key: 0,
        repositories: _ctx.repositories,
        params: _ctx.params
      }, null, 8, ["repositories", "params"]))
    : _createCommentVNode("", true)
}